import styles from './mui-components.module.scss';

export function MuiComponents() {
  return (
    <div className={styles['container']}>
      <h1>Welcome to MuiComponents!</h1>
    </div>
  );
}

export default MuiComponents;
